module.exports = __webpack_public_path__ + "img/4.94f726e5.png";